const Main = ({ classes, children }) => {

    return (

        <main className={classes}>
            {children}
        </main>
    )
}

export default Main
